module.exports = __webpack_public_path__ + "static/media/play-button.183992d9.svg";